import { nextTick } from '@vue/composition-api';import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.timers.js";
import Vue from 'vue';
import { hasFetch, normalizeError, addLifecycleHook } from '../utils';

var isSsrHydration = function isSsrHydration(vm) {
  return vm.$vnode && vm.$vnode.elm && vm.$vnode.elm.dataset && vm.$vnode.elm.dataset.fetchKey;
};

var nuxtState = window.__NUXT__;
export default {
  beforeCreate: function beforeCreate() {
    if (!hasFetch(this)) {
      return;
    }

    this._fetchDelay = typeof this.$options.fetchDelay === 'number' ? this.$options.fetchDelay : 200;
    Vue.util.defineReactive(this, '$fetchState', {
      pending: false,
      error: null,
      timestamp: Date.now()
    });
    this.$fetch = $fetch.bind(this);
    addLifecycleHook(this, 'created', created);
    addLifecycleHook(this, 'beforeMount', beforeMount);
  }
};

function beforeMount() {
  if (!this._hydrated) {
    return this.$fetch();
  }
}

function created() {
  if (!isSsrHydration(this)) {
    return;
  } // Hydrate component


  this._hydrated = true;
  this._fetchKey = this.$vnode.elm.dataset.fetchKey;
  var data = nuxtState.fetch[this._fetchKey]; // If fetch error

  if (data && data._error) {
    this.$fetchState.error = data._error;
    return;
  } // Merge data


  for (var key in data) {
    Vue.set(this.$data, key, data[key]);
  }
}

function $fetch() {
  var _this = this;

  if (!this._fetchPromise) {
    this._fetchPromise = $_fetch.call(this).then(function () {
      delete _this._fetchPromise;
    });
  }

  return this._fetchPromise;
}

function $_fetch() {
  return _$_fetch.apply(this, arguments);
}

function _$_fetch() {
  _$_fetch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var _this2 = this;

    var error, startTime, delayLeft;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            this.$nuxt.nbFetching++;
            this.$fetchState.pending = true;
            this.$fetchState.error = null;
            this._hydrated = false;
            error = null;
            startTime = Date.now();
            _context.prev = 6;
            _context.next = 9;
            return this.$options.fetch.call(this);

          case 9:
            _context.next = 15;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](6);

            if (process.dev) {
              console.error('Error in fetch():', _context.t0);
            }

            error = normalizeError(_context.t0);

          case 15:
            delayLeft = this._fetchDelay - (Date.now() - startTime);

            if (!(delayLeft > 0)) {
              _context.next = 19;
              break;
            }

            _context.next = 19;
            return new Promise(function (resolve) {
              return setTimeout(resolve, delayLeft);
            });

          case 19:
            this.$fetchState.error = error;
            this.$fetchState.pending = false;
            this.$fetchState.timestamp = Date.now();
            this.$nextTick(function () {
              return _this2.$nuxt.nbFetching--;
            });

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[6, 11]]);
  }));
  return _$_fetch.apply(this, arguments);
}